import React from 'react'
import './Styling.css'
import MenuIcon from '@mui/icons-material/Menu'
import Aboutme from './Aboutme'
export default function Nav() {
  return (
    <div className='Nav'>
        <div className='left'>
            <h3>Wijdane CHARKAOUI</h3>
        </div>
        <div className='right'>
        <input type="checkbox"id="check"/>
        <label for="check" class="checkbtn">
            <MenuIcon className='MenuIcon'></MenuIcon>
        </label>
        <ul>
        <li><a href='#Aboutme'>About Me</a></li>
        <li><a href='#myresume'>My Resume</a></li>
        <li><a href='#myskills'>My Skills</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        <li><a href='#footer'>Contact</a></li>
        </ul>  
        </div>  
      
    </div>
  )
}
